import { createSlice } from "@reduxjs/toolkit";
import { getAssignedLicenseAction } from "../../actions/license/getAssignedLicenseAction";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const getAssignedLicenseSlice = createSlice({
  name: "getAssignedLicense",
  initialState,
  reducers: {
    // cleargetUsersState: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAssignedLicenseAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAssignedLicenseAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAssignedLicenseAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getAssignedLicenseSlice.reducer;
